<template>
	<Row>
		<Container>
			<header class="entry-header">
				<h1 class="entry-title">Reviews</h1>
			</header>
			<SharePost :type="'primary'" />

			<div
				class="trustpilot-widget mt-[64px]"
				data-locale="en-US"
				data-template-id="539adbd6dec7e10e686debee"
				data-businessunit-id="5b698af0a68ff100011e6638"
				data-style-height="500px"
				data-style-width="100%"
				data-theme="light"
				data-stars="4,5"
				data-review-languages="en"
			>
				<a
					href="https://www.trustpilot.com/review/www.timothysykes.com"
					target="_blank"
					rel="noopener"
				>
					Trustpilot
				</a>
			</div>
			<Divider />
		</Container>
	</Row>
</template>
<script setup>
useHead({
	title: "Reviews - Timothy Sykes",
	meta: [
		{
			hid: "trustpilot-title",
			name: "trustpilot-title",
			content: "Trustpilot Reviews - Timothy Sykes"
		},
		{
			hid: "trustpilot-description",
			name: "trustpilot-description",
			content: "Read reviews from our satisfied customers on Trustpilot."
		}
	],
	script: [
		{
			async: true,
			type: "text/javascript",
			src: "/js/trustpilot.js"
		}
	]
});

onMounted(() => {
	if (process.client) {
		window.Trustpilot.loadFromElement(
			document.querySelector(".trustpilot-widget"),
			true
		);
	}
});
</script>
<style lang="scss">
.tp-widget-reviews-filter-label {
	display: none !important;
}

.entry-title {
	font-style: normal;
	font-weight: 700;
	line-height: 120%;
	margin-bottom: 24px;
	font-size: 50px;
	font-family: Fira Sans;
}

.trust-pilot-header {
	text-align: center;
}
</style>
